import Vue from 'vue'

/* 接口地址 */
Vue.api = Vue.prototype.$api = {
  /**
   * 写入接口列表
   */
    queryNews: '/news/queryNewsList', // 新闻列表
    News: '/news/queryNewsById' // 详情
}



// WEBPACK FOOTER //
// ./src/api/index.js